"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pricingData = [{
  title: "Amazonian Trek",
  price: "$1,250",
  description: "7 days of deep jungle exploration and wildlife spotting."
}, {
  title: "Icelandic Aurora",
  price: "$2,400",
  description: "Premium glacier tours and northern lights photography."
}, {
  title: "Sahara Nomad",
  price: "$1,850",
  description: "Luxury desert camping and traditional camel caravans."
}];
export default function TrendingEscapes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262752" id="trending-escapes" className="bg-background text-foreground py-16 md:py-24" ref={ref}>
      <div className={`container mx-auto px-4 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-primary uppercase tracking-tight mb-4">
            Trending Escapes
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Curated expeditions for the modern explorer. Discover our most 
            sought-after destinations with transparent, all-inclusive pricing 
            for your next great adventure.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-5xl mx-auto">
          {pricingData.map((item, i) => <Card key={i} data-index={i} className="bg-card border border-border/50 shadow-lg hover:shadow-2xl hover:scale-[1.02] transition-all duration-500 text-center flex flex-col justify-center items-center py-8 backdrop-blur-md">
              <div className="flex flex-col items-center gap-2 text-center px-6">
                <CardTitle className="font-default text-xl font-bold text-foreground uppercase tracking-wider text-center">
                  {item.title}
                </CardTitle>
                <div className="font-mono text-5xl font-bold text-primary-foreground bg-primary px-4 py-2 rounded-md">
                  {item.price}
                </div>
              </div>
              <CardContent className="flex flex-col items-center gap-2">
                <CardDescription className="font-default text-sm mt-4 max-w-[200px] text-muted-foreground leading-relaxed">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        <div className="max-w-5xl mx-auto bg-primary/5 border border-primary/10 rounded-md p-6 text-center backdrop-blur-sm">
          <p className="font-default text-sm md:text-base text-muted-foreground">
            All packages include professional guides, gear, and local transport. 
            Custom itineraries available upon request. <span className="font-bold text-primary uppercase tracking-wide">Initial consultations are always complimentary.</span>
          </p>
        </div>
      </div>
    </section>;
}